import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=465075c6&scoped=true"
import script from "./EditContact.vue?vue&type=script&lang=js"
export * from "./EditContact.vue?vue&type=script&lang=js"
import style0 from "./EditContact.vue?vue&type=style&index=0&id=465075c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465075c6",
  null
  
)

export default component.exports